// extracted by mini-css-extract-plugin
export var colorSquare = "_ou-0";
export var danger = "_ou-5";
export var lightPink = "_ou-8";
export var neutralBlue = "_ou-7";
export var neutralYellow = "_ou-6";
export var normal = "_ou-1";
export var primary = "_ou-2";
export var primaryLight = "_ou-3";
export var solidBlack = "_ou-g";
export var solidGreen = "_ou-b";
export var solidLightBlue = "_ou-d";
export var solidNavy = "_ou-c";
export var solidOrange = "_ou-f";
export var solidPink = "_ou-e";
export var solidRed = "_ou-9";
export var solidYellow = "_ou-a";
export var success = "_ou-4";